import get from 'lodash/get';
import validateHoverDate from '../validateHoverDate';
const NAVIGATE = 'NAVIGATE';
const SELECT = 'SELECT';
const KEYCODES = Object.freeze({
  38: {
    action: NAVIGATE,
    dayDiff: -7
  },
  40: {
    action: NAVIGATE,
    dayDiff: 7
  },
  37: {
    action: NAVIGATE,
    dayDiff: -1
  },
  39: {
    action: NAVIGATE,
    dayDiff: 1
  },
  13: {
    action: SELECT,
    dayDiff: 0
  },
  32: {
    action: SELECT,
    dayDiff: 0
  }
});
/**
 * @public
 * Returns object containing date string and name of action if one matched event's keyCode. Date will be the difference
 * in days between hoveredDate and the difference corresponding to the matched keyCode.
 *
 * This algorithm aims to analogize horizontal and vertical movement within a grid
 * by using the differences in days between the hoveredDate and adjacent date in the given direction to determine if the
 * "cursor" (i.e. focused/hovered date) can advance in that direction.
 */
export default function keyNavHandler(event, hoveredDate, maxSelectableDate, minSelectableDate) {
  const keyCode = Number(event.keyCode);
  const {
    action,
    dayDiff
  } = get(KEYCODES, keyCode.toString(), {
    dayDiff: 0,
    action: null
  });
  return {
    date: validateHoverDate(hoveredDate, dayDiff, maxSelectableDate, minSelectableDate),
    action
  };
}